import { useState, useEffect, useRef } from 'react';

export const useTimeFormatter = () => {
  const [seconds, setSeconds] = useState(0);
  const intervalRef = useRef(null);

  const formatTime = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (hours > 0) {
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    }
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };

  const start = () => {
    if (!intervalRef.current) {
      intervalRef.current = setInterval(() => {
        setSeconds((prev) => prev + 1);
      }, 1000);
    }
  };

  const stop = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  const reset = () => {
    stop();
    setSeconds(0);
  };

  const time = formatTime(seconds);

  return {
    seconds,
    time,
    start,
    stop,
    reset,
  };
};



function useTimer(initialCount = 0) {
    const [count, setCount] = useState(initialCount);
    const [isActive, setIsActive] = useState(false);
    const frameIdRef = useRef(null);
    const lastTimeRef = useRef(null);

    const tick = (timestamp) => {
        if (!lastTimeRef.current) {
            lastTimeRef.current = timestamp;
        }
        const deltaTime = timestamp - lastTimeRef.current;
        
        if (deltaTime >= 1000) {
            setCount(prevCount => prevCount + 1);
            lastTimeRef.current = timestamp;
        }
        
        frameIdRef.current = requestAnimationFrame(tick);
    };

    const startTimer = () => {
        if (!isActive) {
            setIsActive(true);
            frameIdRef.current = requestAnimationFrame(tick);
        }
    };

    const pauseTimer = () => {
        if (isActive) {
            cancelAnimationFrame(frameIdRef.current);
            setIsActive(false);
            lastTimeRef.current = null;
        }
    };

    const resetTimer = () => {
        cancelAnimationFrame(frameIdRef.current);
        setIsActive(false);
        setCount(0);
        lastTimeRef.current = null;
    };

    useEffect(() => {
        return () => {
            if (frameIdRef.current) {
                cancelAnimationFrame(frameIdRef.current);
            }
        };
    }, []);

    return { count, startTimer, pauseTimer, resetTimer };
}

export default useTimer